<template>
    <section   class="files-page" :class="{'hide-has-selected-rows' :showUpload}" >

        <div class="top-bar">
            <div class="top-bar--left">

                <file-mass-action-buttons
                        :files-id="getFilesSelect"
                        v-if="isFilesSelect" >
                </file-mass-action-buttons>

                <b-button @click="handleOpenProjects" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': routeName === 'Projects' }">{{$t("files.navbar.projects")}}
                </b-button>
                <b-button @click="goToFileTab" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': routeName === 'Files' }">{{$t("files.navbar.files")}}
                </b-button>

                <!--<b-button @click="tabIndex=2" size="-tab" variant="-gray"-->
                <!--:class="{ 'btn&#45;&#45;primary': tabIndex === 2 }">Slicing profiles-->
                <!--</b-button>-->
            </div>
            <div class="top-bar--right">
                <b-form-input :placeholder="$t('profiles.search')" v-model="filesSearch" @keydown.enter.native="searchVal=filesSearch" class="inp inp--combo"></b-form-input>
                <b-button variant="-combo btn--ternary btn--outline" @click="searchVal=filesSearch"><i class="icon icon--search"></i></b-button>
                <b-button  v-if="routeName !== 'Profiles'" variant="-primary" @click="showUploadFilePopUp">{{$t("files.action.addFiles")}}</b-button>
                <!--<b-button  v-if="routeName !== 'Profiles'" variant="-secondary" v-b-modal.modal-1>Create design</b-button>-->

                <!--<b-dropdown   v-if="routeName !== 'Profiles'" variant="-ternary btn&#45;&#45;dots no&#45;&#45;arr btn&#45;&#45;outline" text="⋮" right>-->
                    <!--<b-dropdown-item  to="/search">-->
                        <!--Public designs-->
                    <!--</b-dropdown-item>-->
                    <!--<b-dropdown-item-button>-->
                        <!--Create design-->
                    <!--</b-dropdown-item-button>-->
                <!--</b-dropdown>-->
            </div>
        </div>


        <b-tabs >
            <files-upload  @hide="showUpload = false" :show="showUpload"></files-upload>

            <b-tab  v-if="routeName === 'Files'" active>
                <div @dragover.prevent="onDrop(false)" >
                    <files-tab  :search="searchVal"></files-tab>
                </div>
            </b-tab>

            <b-tab v-if="routeName === 'Projects'" class="files-page__projects-tab" active>
                <projects-tab  :show-first-project-files="showFirstProjectFiles" :search="searchVal"></projects-tab>
            </b-tab>

            <b-tab>
                <b-card-text></b-card-text>
            </b-tab>
        </b-tabs>
    </section>
</template>

<script>
  import FilesTab from '@/components/files/FilesTab.vue'
  import ProjectsTab from "../components/projects/ProjectsTab";
  import FilesUpload from "../components/apps/upload/FilesUpload";
  import FileMassActionButtons from "../components/files/FileMassActionButtons";
  import EventBus from "../event/event-bus";
  import {mapGetters, mapActions} from 'vuex'


  export default {
    name: "Files",
    components: {
      ProjectsTab,
      FilesTab,
      FilesUpload,
      FileMassActionButtons,
    },
    data() {
      return {
        filesSearch: null,
        searchVal: null,
        tIndex: 0,
        showUpload: false,
        fileType: 'single',
        projectOpenListener: null,
        showFirstProjectFiles: true,
        showDeletedProfiles: false
      }
    },
    computed:{
      ...mapGetters(['isPrinterTypesLoaded', 'isFilesSelect', 'getFilesSelect']),
      routeName () {
        return this.$route.name
      },

    },
    created() {

      //console.log(this.$route)
      this.projectOpenListener = EventBus.$on('project:open', projectId => {
        if(this.$route.name !== 'Projects'){
          this.$router.push('/projects')
        }
        this.showFirstProjectFiles = !projectId; //Show files of first project if no particular project in event
        //this.tabIndex = 1;
      });

      if (!this.isPrinterTypesLoaded) {
        this.fetchPrinterTypes();
      }
    },
    beforeDestroy() {
      EventBus.$off('project:open', this.projectOpenListener);
    },
    closePopUp(event){
      if(this.showUpload){
        let e=document.getElementById('customdropzone');
        if (!e.contains(event.target)) e.style.display='none';
      }
    },
    methods: {
      ...mapActions(['fetchPrinterTypes', 'removeAllSelectFiles']),
      handleFocusOut(){
        console.log(1)
      },
      outside(el, binding){
        console.log(el, binding)
      },
      onDrop(status){
        console.log(status)
        this.showUpload = status;
      },
      goToFileTab(){
        this.clearVars();
        this.$router.push('/files');
        this.removeAllSelectFiles();
      },
      showUploadFilePopUp() {
        this.showUpload = true;
        //window.createUploadPopup();
        // this.$root.$children[0].$refs.customPopUp.init({
        //   title: 'Upload files',
        //   component: 'FilesUpload',
        //   mClass: 'modal--add-files'
        // })
      },
      handleOpenProjects() {
        this.clearVars();
        this.$router.push('/projects');
        this.removeAllSelectFiles();

      },
      clearVars() {
        this.filesSearch = null;
        this.searchVal = null;
        this.fileType = 'single';
        this.showFirstProjectFiles = true;
        this.showDeletedProfiles = false;
      }
    }
  }
</script>

<style lang="scss">
    @import ".././scss/theme";
    .files-page {
        &.hide-has-selected-rows{
            tr:hover {
                .check {
                    opacity: 0 !important;
                }
            }
            .has-selected-rows {
                display: none;
                .check {
                    opacity: 0 !important;
                }
            }
        }

        &__projects-tab {
            margin-top: 12px;

            .tog {
                background-color: $c-blue;
                padding: 0 8px;
                font-weight: 600;
                font-size: 16px;
                .icon--file {
                    width: 28px;
                    top: -7px;
                    transform: scale(.9);
                    span {
                        color: $c-blue;
                    }
                }
                .inp {
                    position: relative;
                    left: 3px;
                }
                .editable-title {
                    display: flex;
                    align-items: center;
                    .colorpicker {
                        margin-left: 8px;
                    }
                }

            }
            .collapse {
                margin-bottom: 24px;
            }
        }

        .nav-tabs {
            display: none;
        }

        .tog {
            margin-top: 12px;
        }
    }
</style>
